import { render, staticRenderFns } from "./ProjectViewSwitcher.vue?vue&type=template&id=1a2313a9&scoped=true"
import script from "./ProjectViewSwitcher.vue?vue&type=script&lang=js"
export * from "./ProjectViewSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ProjectViewSwitcher.vue?vue&type=style&index=0&id=1a2313a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2313a9",
  null
  
)

export default component.exports